

























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Product, Vat, VatsApi } from '../api';
import VatChartAdmin from '@/components/charts/vat-chart-admin.vue';
import EmptyDistanceGenerator from '@/components/empty-distance-generator.vue';
import VatCurrentStatus from '@/components/charts/vat-currentStatus.vue';
import Toast from './display/toast.vue';

@Component({
	components: {
		VatChartAdmin,
		EmptyDistanceGenerator,
		VatCurrentStatus,
	},
})
export default class VatDisplay extends Vue {
	@Prop(String) public displayName!: string;
	@Prop() public vat!: Vat & { sizeString: string };
	@Prop() public dash!: object;
	@Prop() public product!: Product;
	public emptyVolume: number = 0;
	public vatState: {};
	public savingEmptyDistance: boolean = false;

	public created() {
		this.convertDistanceToVolume().then(emptyVolume => {
			this.emptyVolume = emptyVolume;
		});
	}

	public closeModal(): void {
		this.$bvModal.hide('emptyDistanceModal' + this.vat.id);
	}

	public async updateEmptyDistance(): Promise<void> {
		this.savingEmptyDistance = true;
		const emptyDistance = this.convertVolumeToDistance(this.emptyVolume);
		if (emptyDistance) {
			try {
				await new VatsApi().setEmptyDistance(this.vat.id, { data: { emptyDistance } });
				this.closeModal();
				(this.$refs.vatGraph as VatChartAdmin).loadChart(this.emptyVolume);
				this.successToast(' Empty Distance Updated');
			} catch (e) {
				new Toast().makeToast(
					'Error',
					'There was a problem updating the distance volume',
					'danger',
					true,
				);
			} finally {
				this.savingEmptyDistance = false;
			}
		} else {
			this.savingEmptyDistance = false;
		}
	}

	public goToSensor(type: string) {
		const typeSensor = this.vat.sensors.filter(sensor => sensor.type === type)[0];
		if (typeSensor) {
			this.$router.push({
				name: `sensors.view`,
				params: { sensorId: typeSensor.id },
			} as any);
		}
	}

	private async convertDistanceToVolume(): Promise<number> {
		try {
			let convertDistanceUrl =
				process.env.VUE_APP_API_URL.replace(/\/+$/, '') + '/vats/convert/convertDistance';
			convertDistanceUrl += `?distance=${this.vat.emptyDistance}
        &model=${this.vat.sizeString}
        &offset=${this.vat.vatOffset}
        &formula=${this.vat.formula}
        &height=${this.vat.height}`;
			const emptyVolumeResponse = await this.axios.get(convertDistanceUrl);
			const { emptyVolume } = emptyVolumeResponse.data;
			return Math.round(emptyVolume);
		} catch (e) {
			return 0;
		}
	}

	private convertVolumeToDistance(emptyVolume: number): number | undefined {
		const emptyDistanceGenerator = new EmptyDistanceGenerator();
		try {
			const vatAttributes = emptyDistanceGenerator.calculateVatAttributes(
				`${this.vat.formula}:${this.vat.sizeString}`,
			);
			const emptyDistance = emptyDistanceGenerator.convertVolumeToDistance(
				`${this.vat.formula}:${this.vat.sizeString}`,
				vatAttributes,
				(this.vat.vatOffset || 0) / 1000, // Not sure if this should default to 0. Its based on vat size. Will assume its always set as there is a default offset on vat setup.
				emptyVolume,
			);
			return emptyDistance;
		} catch (e) {
			return;
		}
	}
	public async closeMilkScore() {
		try {
			await new VatsApi().vatsVatIdCloseMilkScoreGet(this.vat.id);
			this.successToast('Closed Milk Score');
		} catch (e) {
			new Toast().makeToast('Error', 'There was a problem closing the milk score', 'danger', false);
		}
	}
	private successToast(toastContent: string): void {
		new Toast().makeToast(`${this.vat.label} ${toastContent}`, 'Success', 'success');
	}
}
